module.exports = "/_next/static/images/game-1-intro-tutorial-phone-uv-86bb3b9bc4e0876f9e94af6032b140df.png";